export default "__VITE_ASSET__DAsoFkpe__"